import { createFileRoute } from "@tanstack/react-router";

import { BlogCategoryPage, categoryHead, guardPage } from "../components/blog/BlogCategoryPage";
import { pageCount, postsForCategory } from "../components/blog/BlogListing";

const BASE_PATH = "/blog/advertising";

export const Route = createFileRoute("/blog/advertising/page/$page")({
  loader: ({ params }) => ({
    page: guardPage(BASE_PATH, params.page, pageCount(postsForCategory("advertising").length)),
  }),
  head: ({ loaderData }) => categoryHead("advertising", loaderData?.page ?? 2),
  component: CategoryPageRoute,
});

function CategoryPageRoute() {
  const { page } = Route.useLoaderData();
  return <BlogCategoryPage categoryKey="advertising" page={page} />;
}
